<template>
  <el-sub-menu v-if="item.children && item.children.length > 0" :key="item.id" :index="item.id + ''">
    <template #title><el-icon><component :is="item.icon"/> </el-icon><span>{{ item['name'] }}</span></template>
    <menu-item v-for="(child) in item.children" :key="child.id" :item="child"/>
  </el-sub-menu>
  <el-menu-item v-else :index="item.url" :key="item.url">
<!--    <el-icon><component :is="item.icon"/> </el-icon>-->
    {{ item['name'] }}
  </el-menu-item>
</template>

<script>
import { ElMenuItem, ElSubMenu } from 'element-plus';
export default {
  components: { ElMenuItem, ElSubMenu },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>

</style>